import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { LoginComponent } from './components/login/login.component';
import { ZyuushoApiComponent } from './components/zyuusho-api/zyuusho-api.component';
import { ZyuushoSearchApiComponent } from './components/zyuusho-search-api/zyuusho-search-api.component';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { DateStringPipe } from './pipe/date-string.pipe';

import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { LoadingComponent } from './loading.component';

import { SharedLibConfig } from './config/shared-lib-config';
import { SHARED_LIB_CONFIG } from './config/shared-lib-config.token';
import { Sgkz002dComponent } from './components/sgkz002d/components/sgkz002d.component';
import { Sgkz006dComponent } from './components/sgkz006d/components/sgkz006d.component';
import { Sgkz007dComponent } from './components/sgkz007d/components/sgkz007d.component';

/**
 * 共通モジュール
 * @export
 * @class SharedModule
 */
@NgModule({
  declarations: [
    ZyuushoApiComponent,
    ZyuushoSearchApiComponent,
    FooterComponent,
    HeaderComponent,
    LoginComponent,
    OnlyNumberDirective,
    DateStringPipe,
    LoadingComponent,
    Sgkz002dComponent,
    Sgkz006dComponent,
    Sgkz007dComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatTableModule,
    MatToolbarModule,
    MatTabsModule,
    MatRadioModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatStepperModule,
    MatExpansionModule,
    MatGridListModule,
    MatBottomSheetModule,
    MatMenuModule,
    MatAutocompleteModule,
    FlexLayoutModule,
    MatPaginatorModule,
    MatSortModule,
    MatDialogModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatTableModule,
    MatToolbarModule,
    MatTabsModule,
    MatRadioModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatStepperModule,
    MatExpansionModule,
    MatGridListModule,
    MatBottomSheetModule,
    MatMenuModule,
    MatAutocompleteModule,
    FlexLayoutModule,
    MatPaginatorModule,
    MatSortModule,
    MatDialogModule,

    ZyuushoApiComponent,
    ZyuushoSearchApiComponent,
    FooterComponent,
    HeaderComponent,
    LoginComponent,
    OnlyNumberDirective,
    LoadingComponent,
    DateStringPipe,
    Sgkz002dComponent,
    Sgkz006dComponent,
    Sgkz007dComponent
  ]
})
export class SharedModule {
  public static forRoot(sharedLibConfig: SharedLibConfig): ModuleWithProviders<SharedModule> {
    console.log("call shared forRoot");
    return {
      ngModule: SharedModule,
      providers: [
        { provide: SHARED_LIB_CONFIG, useValue: sharedLibConfig }
      ]
    };
  }
}
